import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/joy';
import { getCustomerNameFromFilterModel } from './getCustomerNameFromFilterModel';

const DashboardReportPrintCover = ({ title = 'Stato parco', printedAtLabel, filterModel }) => {
    const [logoMarkup, setLogoMarkup] = useState('');
    const customerName = useMemo(() => getCustomerNameFromFilterModel(filterModel), [filterModel]);
    const headline = customerName ? `Stato parco per ${customerName}` : title;

    useEffect(() => {
        const logoElement = document.querySelector('.logo');
        setLogoMarkup(logoElement?.innerHTML ?? '');
    }, []);

    return (
        <Box className="mtska-dashboard-print-cover">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', float: 'right', width: '100%' }}>
                {logoMarkup ? (
                    <Box className="logo" dangerouslySetInnerHTML={{ __html: logoMarkup }} />
                ) : null}
                <Box className="mtska-dashboard-print-cover-brand">Consecution</Box>
            </div>
       
            <Box className="mtska-dashboard-print-cover-title">{headline}</Box>
            {printedAtLabel ? (
                <Box className="mtska-dashboard-print-cover-date">{printedAtLabel}</Box>
            ) : null}
        </Box>
    );
};

export default DashboardReportPrintCover;
